import { useContext } from "react";
import constants from "../../constants";
import AlertContext from "../../context/AlertContext";
import StudentTestContainerHooks from "./StudentTestContainerHooks";
import StudentTestPageCalcStatsHooks from "./StudentTestPageCalcStatsHooks";
import { StudentTestPageContext } from "../../context/StudentTestPageContext";
import StudentTestPageQuestionUpdateHooks from "./StudentTestPageQuestionUpdateHooks";
import { getDataFromStorage } from "../../util";
import { useLocation, useNavigate } from "react-router-dom";

export default function StudentTestBodyPageHooks() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);
  const navigate = useNavigate();
  const location = useLocation()

  const { setFilters } = StudentTestContainerHooks();
  const { calcStats } = StudentTestPageCalcStatsHooks();
  const { questionUpdate } = StudentTestPageQuestionUpdateHooks();

  const showTranscriptFunc = () => {
    StudentTestPageCxt.setShowTranscript(!StudentTestPageCxt.showTranscript);
  };

  const handleSingleVdoQnSubmit = () => {
    Alert.setSingleVdoSubmit(true);
  };

  /* Book mark questions */

  const showAnswer = () => {
    StudentTestPageCxt.setShowSaqLaqAns(!StudentTestPageCxt.showSaqLaqAns);
  };

  /* change the questions view list and grid */

  const changeQuestionVisible = (visible) => {
    if (visible === "single") {
      if (Alert.questionContainerSingle === false) {
        Alert.updateQuestionContainerSingle(true);
      }
    } else if (visible === "multiple") {
      StudentTestPageCxt.setShowSaqLaqAns(false);
      Alert.comingObj.visible = Alert.comingObj.previsited;

      if (Alert.questionContainerSingle === true) {
        Alert.updateQuestionContainerSingle(false);
      }
    }
  };

  const backToHomePage = () => {
    console.log("1");
    if (StudentTestPageCxt.showTranscript)
      StudentTestPageCxt.setShowTranscript(!StudentTestPageCxt.showTranscript);
    if (StudentTestPageCxt.showSaqLaqAns)
      StudentTestPageCxt.setShowSaqLaqAns(!StudentTestPageCxt.showSaqLaqAns);

    if (Alert.testData.testmode === constants.MODE.PRACTICE_MODE) {
      Alert.setLpData({});
      Alert.setHalfDonut(false);
      Alert.setHalfDonutChart({});
      Alert.answerRef.current = {};
      Alert.PractSingleQnId.current = "";
      Alert.PractSingleQnAns.current = false;
      Alert.PractSingleQnFinalSubmit.current = false;
    }

    if (
      Alert.isFromProfile.current ||
      getDataFromStorage("role") === "customer"
    ) {
      Alert.navigate("/profiles/testpoints");
    } else {
      console.log("location.state",location.state);
      
      if (Alert.isAdmin) {
        if (Alert.showBreadCrumbsData?.from === "user") {
          Alert.setShowPopup(true);
          Alert.navigate(`batches/${sessionStorage.getItem("abatchid")}/users`, {...location.state});
        } else if (Alert.showBreadCrumbsData?.from === "old") {
          Alert.navigate(
            `batches/${sessionStorage.getItem("abatchid")}/report`,
          );
        } else {
          Alert.setMcqAndDesTestAndLpId({});
          console.log("CLICKING BACK", Alert.testData);
          if (Alert.testData.mockuse) {
            Alert.navigate(
              `batches/${sessionStorage.getItem(
                "abatchid",
              )}/dashboard?scope-ar=mock-test`,
            );
          }
          else {
            Alert.navigate(
              `batches/${sessionStorage.getItem(
                "abatchid",
              )}/path/${sessionStorage.getItem("aPathId")}/report#`,
            );
          }
          // navigate(-1);
        }
      } else if (Alert.backupTestData.mockuse) {
        console.log("Backup test :",Alert.backupTestData);
        if(Alert.backupTestData.mockuse==1) console.log("Hitted");
        if(Alert.backupTestData.scope=="COMPANY") Alert.navigate("main/company_specific/results");
        else if (Alert.backupTestData.scope=="TECH")  Alert.navigate("main/technology_specific/results");
        else Alert.navigate("main/mock/results");
      } else if (Alert.showBreadCrumbsData?.from === "learner") {
        Alert.navigate("/main/dashboard/testresults");
      } else {
        Alert.setLpData({});
        Alert.navigate("/home");
      }
    }
  };

  /* vdo qn getting the sectionname  */

  const getSectionName = (qnid) => {
    for (let sec of Alert.comingObj.sections) {
      if (sec.questions.find((que) => que.id === qnid)) {
        return sec.sectionname;
      }
    }

    return null;
  };

  /* vdo qn getting the qn no  */

  const getQuestionNo = (qnid) => {
    for (let sec of Alert.comingObj.sections) {
      const questionIndex = sec.questions.findIndex((que) => que.id === qnid);

      if (questionIndex !== -1) {
        return questionIndex + 1;
      }
    }

    return null;
  };

  /* move to previous question */

  const traversePrevious = () => {
    let tempQueInd = Alert.queInd;
    let tempSecInd = Alert.secInd;

    if (
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].answered === -1
    ) {
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        "not";
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited =
        "not";
    }

    if (
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].answered === 0
    ) {
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        "completed";
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited =
        "completed";
    }

    if (Alert.queLen > 1 && Alert.queInd > 0) {
      tempQueInd--;

      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited;
      Alert.setQueInd(Alert.queInd - 1);
      Alert.setNextButton(true);
    } else {
      tempSecInd--;
      Alert.setSecInd(Alert.secInd - 1);
      Alert.setNextButton(true);
      tempQueInd = Alert.comingObj.sections[tempSecInd].questions.length - 1;

      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited;
      Alert.setQueInd(tempQueInd);
    }

    if (tempSecInd === 0 && tempQueInd === 0) {
      Alert.setPrevButton(false);
    }

    questionUpdate(tempSecInd, tempQueInd, Alert.comingObj);

    if (
      Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.EVALUATED
    ) {
      setFilters(null);
    }
  };

  /* move to next question */

  const traverseNext = (key) => {
    let tempSecInd = Alert.secInd;
    let tempQueInd = Alert.queInd;
    Alert.PractSingleQnAns.current = false;
    Alert.PractSingleQnId.current = "";

    if (
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].answered === -1
    ) {
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        "not";
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited =
        "not";
    }

    if (
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].answered === 0
    ) {
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        "completed";
      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited =
        "completed";
    }

    if (
      Alert.comingObj.sections[tempSecInd].questions.length ===
      tempQueInd + 1 &&
      Alert.comingObj.sections?.length >= tempSecInd + 1
    ) {

      tempSecInd++;
      tempQueInd = 0;

      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        Alert.comingObj.sections[tempSecInd]?.questions[tempQueInd].previsited;

      questionUpdate(tempSecInd, tempQueInd, Alert.comingObj);
      Alert.setPrevButton(true);
    } else {
      tempQueInd++;

      Alert.comingObj.sections[tempSecInd].questions[tempQueInd].visited =
        Alert.comingObj.sections[tempSecInd].questions[tempQueInd].previsited;

      questionUpdate(tempSecInd, tempQueInd, Alert.comingObj);
      Alert.setPrevButton(true);
    }

    if (
      Alert.comingObj.sections?.length === tempSecInd + 1 &&
      Alert.comingObj.sections[tempSecInd].questions.length === tempQueInd + 1
    ) {
      Alert.setPrevButton(true);
      Alert.setNextButton(false);
    }

    if (
      Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.EVALUATED
    ) {
      setFilters(null);
    }

    Alert.setSecInd(tempSecInd);
    Alert.setQueInd(tempQueInd);
  };

  //   const traverseNext = (key) => {
  //     let tempSecInd = Alert.secInd;
  //     let tempQueInd = Alert.queInd;
  //     Alert.PractSingleQnAns.current = false;
  //     Alert.PractSingleQnId.current = "";

  //     // Update current question status
  //     const currentQuestion = Alert.comingObj.sections[tempSecInd].questions[tempQueInd];
  //     if (currentQuestion.answered === -1) {
  //         currentQuestion.visited = "not";
  //         currentQuestion.previsited = "not";
  //     } else if (currentQuestion.answered === 0) {
  //         currentQuestion.visited = "completed";
  //         currentQuestion.previsited = "completed";
  //     }

  //     // Get the current question's topic and complexity
  //     const currentTopicId = currentQuestion.topicid;
  //     const currentComplexityId = currentQuestion.complexityid;

  //     // Find the corresponding qnconfig for this question
  //     const section = Alert.comingObj.sections[tempSecInd];
  //     const qnConfig = section.qnconfig.find(
  //         config => config.topicid === currentTopicId && 
  //                   config.complexityid === currentComplexityId
  //     );

  //     if (!qnConfig) {
  //         console.error("No qnconfig found for topicid:", currentTopicId, "complexityid:", currentComplexityId);
  //         return;
  //     }

  //     // Calculate total questions needed for this topic-combination
  //     const totalNeeded = qnConfig.fixedqncount + qnConfig.qncount;

  //     // Count how many questions of this topic-combination are completed
  //     let completedCount = 0;
  //     const allQuestions = section.questions;

  //     for (const question of allQuestions) {
  //         if (question.topicid === currentTopicId && 
  //             question.complexityid === currentComplexityId && 
  //             question.answered === 0) {
  //             completedCount++;
  //         }
  //     }

  //     // Check if we've completed all required questions for this topic-combination
  //     const isTopicCompleted = completedCount >= totalNeeded;

  //     // Find the next question to navigate to
  //     let foundNext = false;
  //     let nextSecInd = tempSecInd;
  //     let nextQueInd = tempQueInd;

  //     // First, try to find next question in current section
  //     if (tempQueInd + 1 < section.questions.length) {
  //         nextQueInd = tempQueInd + 1;
  //         foundNext = true;
  //     } 
  //     // If no more questions in current section, try next section
  //     else if (tempSecInd + 1 < Alert.comingObj.sections.length) {
  //         nextSecInd = tempSecInd + 1;
  //         nextQueInd = 0;
  //         foundNext = true;
  //     }

  //     // If topic is completed and we found next question, check if we should skip it
  //     // if (isTopicCompleted && foundNext) {
  //     //   console.log("Third condition");

  //     //   const nextQuestion =
  //     //     Alert.comingObj.sections[nextSecInd]?.questions[nextQueInd];

  //     //   // Skip questions that belong to the completed topic-combination
  //     //   if (
  //     //     nextQuestion &&
  //     //     nextQuestion.topicid === currentTopicId &&
  //     //     nextQuestion.complexityid === currentComplexityId
  //     //   ) {
  //     //     // Try to find a question from a different topic-combination
  //     //     console.log("Fourth");

  //     //     foundNext = false;
  //     //     let searchSecInd = tempSecInd;
  //     //     let searchQueInd = tempQueInd;
  //     //     console.log("searchSecInd:",searchSecInd,"searchQueInd:",searchQueInd);


  //     //     while (searchSecInd < Alert.comingObj.sections.length) {
  //     //       console.log("While condition");

  //     //       const currentSection = Alert.comingObj.sections[searchSecInd];

  //     //       while (searchQueInd + 1 < currentSection.questions.length) {
  //     //         console.log("Second While");

  //     //         searchQueInd++;
  //     //         const potentialQuestion = currentSection.questions[searchQueInd];
  //     //         console.log("potentialQuestions:",potentialQuestion);

  //     //         if (
  //     //           !(
  //     //             potentialQuestion.topicid === currentTopicId &&
  //     //             potentialQuestion.complexityid === currentComplexityId
  //     //           )
  //     //         ) {
  //     //           foundNext = true;
  //     //           nextSecInd = searchSecInd;
  //     //           nextQueInd = searchQueInd;
  //     //           break;
  //     //         }
  //     //       }

  //     //       if (foundNext) break;

  //     //       // Move to next section
  //     //       searchSecInd++;
  //     //       if (searchSecInd < Alert.comingObj.sections.length) {
  //     //         searchQueInd = -1; // Will be incremented to 0 in next iteration
  //     //       }
  //     //     }
  //     //   }
  //     // }
  //     console.log("FoundNext in next function:", foundNext,typeof foundNext);

  //     // Update the found question's visited status
  //     if (foundNext) {
  //         const nextQuestion = Alert.comingObj.sections[nextSecInd].questions[nextQueInd];
  //         nextQuestion.visited = nextQuestion.previsited;

  //         questionUpdate(nextSecInd, nextQueInd, Alert.comingObj);
  //         Alert.setPrevButton(true);
  //     }

  //     // Check if we're at the last question
  //     if (nextSecInd === Alert.comingObj.sections.length - 1 && 
  //         nextQueInd === Alert.comingObj.sections[nextSecInd].questions.length - 1) {
  //         Alert.setPrevButton(true);
  //         Alert.setNextButton(false);
  //     }

  //     if (Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.EVALUATED) {
  //         setFilters(null);
  //     }

  //     Alert.setSecInd(nextSecInd);
  //     Alert.setQueInd(nextQueInd);
  // };

  /* collect score */

  const collectScores = (qid, scor, maxscore, e) => {
    if (isNaN(scor) === false) {
      let score = Number(scor);
      let tScore = StudentTestPageCxt.currentScore;
      let tempScores = Alert.descScores;

      tempScores = { ...tempScores, [qid]: score };

      let tempErrors = StudentTestPageCxt.scoreErrors;

      if (score > maxscore || score === "" || score < 0) {
        if (Object.keys(tempErrors).length > 0) {
          StudentTestPageCxt.setHasScoreErrors(true);
        } else {
          StudentTestPageCxt.setHasScoreErrors(false);
        }

        if (score === "") {
          if (Object.keys(tempScores).map(Number)?.includes(qid)) {
            tScore = tScore - Alert.tsCoBkup[qid];

            if (Alert.ansStats.evalids?.includes(parseInt(qid))) {
              tScore = tScore + Alert.ansStats.idscore[qid];
            }
          } else {
            if (Alert.ansStats.evalids?.includes(parseInt(qid))) {
              tScore = tScore + Alert.ansStats.idscore[qid];
            }
          }

          Alert.setDescScores(tempScores);
          delete tempScores[qid];

          tempErrors = { ...tempErrors, [qid]: true };
          StudentTestPageCxt.setScoreErrors(tempErrors);
        }

        if (score > maxscore) {
          tempScores = { ...tempScores, [qid]: maxscore };
          Alert.setDescScores(tempScores);

          if (Object.keys(Alert.tsCoBkup).map(Number)?.includes(qid)) {
            tScore = tScore - Alert.tsCoBkup[qid];
          } else if (Alert.ansStats.evalids?.includes(Number(qid))) {
            tScore = tScore - Alert.ansStats.idscore[qid];
          }

          tScore = tScore + maxscore;
          Alert.setDescScores(tempScores);
        }

        if (score < 0) {
          tempScores = { ...tempScores, [qid]: 0 };
          Alert.setDescScores(tempScores);
        }
      } else {
        if (tempErrors.hasOwnProperty(qid)) {
          delete tempErrors[qid];
        }

        if (Object.keys(tempScores).map(Number)?.includes(qid)) {
          if (Object.keys(Alert.tsCoBkup).map(Number)?.includes(qid)) {
            tScore = tScore - Alert.tsCoBkup[qid];
          } else if (Alert.ansStats?.evalids?.includes(Number(qid))) {
            tScore = tScore - Alert.ansStats.idscore[qid];
          }

          tScore = tScore + score;
        } else {
          if (Alert.ansStats.evalids?.includes(parseInt(qid))) {
            tScore = tScore - Alert.ansStats.idscore[qid];
            tScore = tScore + score;
          } else {
            tScore = tScore + score;
          }
        }

        Alert.setDescScores(tempScores);
      }

      StudentTestPageCxt.setCurrentScore(tScore);
      StudentTestPageCxt.setEvalComp(true);

      for (const property in tempScores) {
        if (tempScores[property] == null) {
          StudentTestPageCxt.setEvalComp(false);
        }
      }

      Alert.setTsCoBkup(tempScores);

      for (let i = 0; i < Alert.comingObj.sections?.length; i++) {
        for (let j = 0; j < Alert.comingObj.sections[i].questions.length; j++) {
          if (
            Alert.comingObj.sections[i].questions[j].answer === "" &&
            Alert.comingObj.sections[i].questions[j].id === qid
          ) {
            StudentTestPageCxt.setGiveZeros(false);
            break;
          }
        }
      }
    }
  };

  /* Collect ans and showing error msg */

  /* change section  */

  const handleSecChange = (event) => {
    const selectedValue = event.target.value;
    const isAllSections = selectedValue === "all";
    const selectedSectionIndex = isAllSections ? null : Number(selectedValue);
    const sections = Alert.comingObj.sections;

    StudentTestPageCxt.setSelSec(
      isAllSections ? "all" : selectedSectionIndex
    );
    StudentTestPageCxt.setSectionObj(
      isAllSections ? {} : sections[selectedSectionIndex]
    );

    if (isAllSections) {
      StudentTestPageCxt.setPrevSec(false);
      StudentTestPageCxt.setNextSec(sections.length > 1);
    } else if (sections.length === 1) {
      StudentTestPageCxt.setPrevSec(false);
      StudentTestPageCxt.setNextSec(false);
    } else if (selectedSectionIndex === 0) {
      StudentTestPageCxt.setPrevSec(false);
      StudentTestPageCxt.setNextSec(true);
    } else if (selectedSectionIndex === sections.length - 1) {
      StudentTestPageCxt.setPrevSec(true);
      StudentTestPageCxt.setNextSec(false);
    } else {
      StudentTestPageCxt.setPrevSec(true);
      StudentTestPageCxt.setNextSec(true);
    }

    if (!isAllSections) {
      StudentTestPageCxt.setSecIndex(selectedSectionIndex);
    }

    calcStats(Alert.comingObj, [isAllSections ? "all" : selectedSectionIndex]);

    if (
      Alert.mcqAndDesTestAndLpId.status === constants.PROGRESS_STATUS.EVALUATED
    ) {
      setFilters(null);
    }
  };

  const startListening = () => {
    if (StudentTestPageCxt.recognitionRef.current) {
      StudentTestPageCxt.recognitionRef.current.start();
      StudentTestPageCxt.setListening(true);
    }
  };

  const stopListening = () => {
    if (StudentTestPageCxt.recognitionRef.current) {
      StudentTestPageCxt.recognitionRef.current.stop();
      StudentTestPageCxt.setListening(false);
    }
  };

  return {
    showAnswer,
    traverseNext,
    getQuestionNo,
    collectScores,
    stopListening,
    getSectionName,
    backToHomePage,
    startListening,
    handleSecChange,
    traversePrevious,
    showTranscriptFunc,
    changeQuestionVisible,
    handleSingleVdoQnSubmit,
  };
}
